export default {
  login: {
    form: {
      username: {
        label: 'Username',
        placeholder: 'username',
      },
      password: {
        label: 'Password',
        placeholder: 'password',
      },
      submit: 'Sign in',
    },
    errors: {
      invalidCredentials: 'Email and/or password are incorrect.',
    },
    forgotPassword: 'Forgot your password?',
  },
  forgetPassword: {
    title: 'Please enter your email below.',
    form: {
      email: {
        placeholder: 'Email',
      },
      submit: 'Send password reset request',
    },
    errors: {
      invalidEmail: 'Invalid email.',
    },
    successMessage: 'We sent you an email with a password reset link!',
  },
  recoverPassword: {
    title: 'Enter your new password.',
    form: {
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      newPassword: {
        label: 'New password',
      },
      confirmPassword: {
        label: 'Confirm your new password',
        invalid: 'Passwords do not match.',
      },
      submit: 'Submit',
    },
    errors: {
      typeNewPassword: 'Enter your new password',
      passwordsDoNotMatch: 'Passwords do not match.',
    },
    successMessage: 'Password changed successfully!',
    login: 'Back to login',
  },
  form: {
    password: {
      placeholder: '********',
    },
  },
  navbar: {
    menu: {
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Log out',
    },
  },
  newPassword: {
    title: 'Enter your new password.',
    oldPass: 'Current password',
    newPass: 'New password',
    confirmNewPass: 'Confirm new password',
    placeholders: {
      pass: 'Password',
    },
    send_button: 'Submit',
    error_confirm: 'Passwords do not match.',
  },
  sidebar: {
    logoAlt: 'Management system',
    menu: {
      dashboard: 'Dashboard',

      tools: {
        generate: 'Text generator',
        breakText: 'Break text into lines',
        wordSeparator: 'Word separator',
        specialCharacterRemover: 'Special character remover',
        wordGroups: 'Word grouper',
      },

      words: {
        title: 'Word bank',
        list: 'Word list',
        import: 'Import words',
        add: 'Add words',
      },

      games: {
        title: 'Games',

        cryptograms: {
          title: 'Cryptograms',
          list: 'List',
          add: 'Add',
        },

        crosswords: {
          title: 'Crosswords',
          list: 'List',
          add: 'Add',
          templates: 'Template list',
        },

        huntingWords: {
          title: 'Word search',
          list: 'List',
          add: 'Add',
        },

        shapeLinks: {
          title: 'Shape Links',
          list: 'List',
          add: 'Add',
        },

        loop: {
          title: 'Loop',
          list: 'List',
          add: 'Add',
        },

        numberSquare: {
          title: 'Number Square',
          list: 'List',
          add: 'Add',
        },

        fences: {
          title: 'Fences',
          list: 'List',
          add: 'Add',
        },

        walls: {
          title: 'Walls',
          list: 'List',
          add: 'Add',
        },

        term: {
          title: 'Term',
          list: 'List',
        },
      },

      users: {
        title: 'Users',
        list: 'List',
        add: 'Add',
      },
    },
  },
  shared: {
    actions: {
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      back: 'Back',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      generate: 'Generate',
      clear: 'Clear',
      copy: 'Copy',
      copyText: 'Copy text',
      import: 'Import',
      export: 'Export',
      search: 'Search',
    },
    fonts: {
      placeholder: 'Select font...',
      numbers: 'Numbers {n}',
      symbols: 'Symbols {n}',
      fontCrypto: 'Font Crypto {n}',
    },
    pagination: {
      summary: 'Showing {from} to {to} of {total} records',
      noResults: 'No results found',
      prev: 'Previous',
      next: 'Next',
    },
    puzzle: {
      columns: {
        name: 'Name',
        template: 'Template',
        status: 'Status',
        level: 'Level',
        options: 'Options',
      },
      status: {
        draft: 'Draft',
        completed: 'Completed',
      },
      noContent: 'No games have been created yet.',
      selectGames: 'Select games',
      complete: 'Complete ({count})',
      export: 'Export ({count})',
      noSelected: 'No games selected',
      game: 'game',
      template: 'template',
      deleteTitle: 'Confirm deletion of {label}',
      deleteMessage: 'Are you sure you want to delete the {label} "{name}"?',
    },
    confirmation: {
      title: 'Confirm deletion',
      message: 'Are you sure you want to delete',
    },
    gameStatus: {
      summary: '{placed} of {total} words {description}',
    },
    level: {
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
    },
    export: {
      title: 'Export files',
      fileFormat: 'File format:',
      style: 'Style:',
      unexpectedError: 'An unexpected error occurred during export.',
      noFiles: 'No files to export.',
      converting: 'Converting {current} of {total} files...',
      conversionError:
        'An error occurred while converting SVG to EPS. Please try again.',
      finishing: 'Finishing export...',
      types: {
        enigma: 'Puzzle',
        solution: 'Solution',
        combined: 'Puzzle + Solution',
        wordList: 'Word list',
        gridTxt: 'Grid TXT',
      },
      toggles: {
        colored: 'Colored',
        transparentBg: 'Transparent background',
        exportBank: 'Include word bank',
      },
      radio: {
        arrowStyle: {
          label: 'Arrow type:',
          triangle: 'Triangle',
          filledCircle: 'Filled circle',
          emptyCircle: 'Empty circle',
          dottedCircle: 'Circle with dot',
        },
        pathWeight: {
          label: 'Line thickness:',
          thin: 'Thin',
          normal: 'Normal',
          bold: 'Thick',
        },
      },
    },
    distribution: {
      checkboxLabel: 'Distribute words by percentage',
      tooltip:
        'Words are distributed according to the percentages. If there is not enough space, other directions will be used.',
      placeholder: 'Number in %',
      total: 'Total:',
      mustSum100: '(must add up to 100%)',
    },
    upload: {
      dropOrChoose: 'Drop (or choose) a file',
      clickOrDrag: 'Click or drag the file here',
      selectImage: 'Select an image',
    },
    select: {
      placeholder: 'Select...',
    },
    scrollToTop: {
      tooltip: 'Back to top',
    },
    alert: {
      seconds: 'sec.',
    },
    deletedSuccess: 'Game deleted successfully',
    dashboard: {
      noResults: 'No results found.',
      viewAll: 'View all →',
      statusRegisters: {
        title: 'Records by status',
      },
      lastRegisters: {
        title: 'Latest records',
        filters: {
          lastWeek: 'Last week',
          today: 'Today',
          lastMonth: 'Last month',
          lastYear: 'Last year',
        },
      },
      status: {
        open: 'Draft',
        pending: 'Pending',
        approved: 'Approved',
        canceled: 'Canceled',
        closed: 'Completed',
      },
    },
    editor: {
      placeholder: 'Formatted text',
    },
    input: {
      total: 'Total',
    },
    stats: {
      label: 'Label',
    },
    loader: {
      generating: 'Generating...',
      cancelled: 'Generation canceled.',
    },
  },
};
